/**
 * WordPress dependencies
 */
import { symbol as icon } from '@wordpress/icons';
/**
 * Internal dependencies
 */

const metadata = {
  $schema: "https://schemas.wp.org/trunk/block.json",
  apiVersion: 2,
  name: "core/block",
  title: "Reusable block",
  category: "reusable",
  description: "Create and save content to reuse across your site. Update the block, and the changes apply everywhere it\u2019s used.",
  textdomain: "default",
  attributes: {
    ref: {
      type: "number"
    }
  },
  supports: {
    customClassName: false,
    html: false,
    inserter: false
  },
  editorStyle: "wp-block-editor"
};
import edit from './edit';
const {
  name
} = metadata;
export { metadata, name };
export const settings = {
  edit,
  icon
};
//# sourceMappingURL=index.js.map